import { useState } from "react";
import {
  KeyRound,
  Lock,
  Eye,
  EyeOff,
  ShieldCheck,
} from "lucide-react";

import ProfilePageLayout from "../../components/profile/ProfilePageLayout";

export default function ChangePassword() {

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (
      form.new_password !==
      form.confirm_password
    ) {
      alert("Las contraseñas no coinciden.");
      return;
    }

    /*
      Posteriormente:

      API.post("/auth/change-password/", form)
    */
  };

  return (
    <ProfilePageLayout
      title="Cambiar contraseña"
      subtitle="Protege tu cuenta manteniendo una contraseña segura."
      icon={KeyRound}
    >

      <div className="profile-security-layout">

        <section className="profile-template-card">

          <div className="profile-card-title">

            <KeyRound size={21} />

            <div>
              <h2>Nueva contraseña</h2>
              <p>
                Actualiza las credenciales de acceso
              </p>
            </div>

          </div>

          <form
            className="profile-password-form"
            onSubmit={handleSubmit}
          >

            <label>
              Contraseña actual

              <div className="profile-input-wrapper">

                <Lock size={17} />

                <input
                  type={
                    showCurrent
                      ? "text"
                      : "password"
                  }
                  name="current_password"
                  value={form.current_password}
                  onChange={handleChange}
                  placeholder="••••••••"
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowCurrent(
                      (value) => !value
                    )
                  }
                >
                  {showCurrent
                    ? <EyeOff size={17} />
                    : <Eye size={17} />}
                </button>

              </div>
            </label>

            <label>
              Nueva contraseña

              <div className="profile-input-wrapper">

                <Lock size={17} />

                <input
                  type={
                    showNew
                      ? "text"
                      : "password"
                  }
                  name="new_password"
                  value={form.new_password}
                  onChange={handleChange}
                  placeholder="••••••••"
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowNew(
                      (value) => !value
                    )
                  }
                >
                  {showNew
                    ? <EyeOff size={17} />
                    : <Eye size={17} />}
                </button>

              </div>
            </label>

            <label>
              Confirmar contraseña

              <div className="profile-input-wrapper">

                <Lock size={17} />

                <input
                  type={
                    showConfirm
                      ? "text"
                      : "password"
                  }
                  name="confirm_password"
                  value={form.confirm_password}
                  onChange={handleChange}
                  placeholder="••••••••"
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowConfirm(
                      (value) => !value
                    )
                  }
                >
                  {showConfirm
                    ? <EyeOff size={17} />
                    : <Eye size={17} />}
                </button>

              </div>
            </label>

            <button
              type="submit"
              className="profile-neon-button"
            >
              <ShieldCheck size={18} />
              ACTUALIZAR CONTRASEÑA
            </button>

          </form>

        </section>

        <aside className="profile-template-card profile-password-tips">

          <ShieldCheck size={32} />

          <h3>
            CUENTA SEGURA
          </h3>

          <p>
            Utiliza una contraseña única y evita
            compartir tus credenciales.
          </p>

          <ul>
            <li>Mínimo 8 caracteres</li>
            <li>Combina letras y números</li>
            <li>Evita datos personales</li>
          </ul>

        </aside>

      </div>

    </ProfilePageLayout>
  );
}